<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="1200_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      noPadding
    >
    <template #header>应用对象详情</template>
    <template #content>
        <app-base-main parentTable :table-shadow="false">
        <template #filter-group>
          <app-filter-group  @query="$gjQuery" @reset="$gjReset" :isBr="clientWidth > 1366 ? false : true">
            <gj-market-select
                multiple
                v-model="filter.marketIdList"
                placeholder="全部站点"
                width="200px"
            ></gj-market-select>
            <gj-select
                v-model="filter.adsStatus"
                :options="option.activeStatsOption"
                placeholder="活跃状态"
                width="140px"
            ></gj-select>
              <gj-select
                v-model="filter.templateState"
                :options="option.ruleStatsOption"
                placeholder="状态"
                width="140px"
            ></gj-select>
              <gj-search-input
                v-model="filter.objectName"
                width="180px"
                placeholder="请输入应用对象名称"
            ></gj-search-input>
          </app-filter-group>
        </template>
        <template  #operate-group>
            <gj-button type="primary" @click="editAllEvent('paused')">暂停</gj-button>
            <gj-button  @click="editAllEvent('archived')" v-if="$permission('adsStrategyObject:delete')">移除</gj-button>
            <gj-button @click="editAllEvent('enabled')">开启</gj-button>
         </template>
        <template #table>
            <gj-table
                name="seletionApply"
                :index="false"
                :adapt-height="false"
                :height="440"
                :data="tableData"
                selection
                :loading="loading"
                :columns="columns"
                :show-overflow="false"
                :pagination="pagination"
                @sort-change="$gjSortChange"
                @page-change="$gjNoticeQuery"
                @selection-change="handleSelectionChange"
            >
            <template v-slot:objectName="{ row }">
              <div>
              <div style="margin-bottom: 4px;">{{ row.objectName | defaultShow }}</div>
              <el-tag
                size="mini"
                type="info"
                style="margin-right: 10px"
                v-if="row.objectType"
                >{{ optionMap[row.objectType] }}</el-tag
              >
              <el-tag size="mini" type="success" v-if="row.adsStatus === 1">{{
                row.adsStatus === 1 ? '活跃' : '不活跃' 
              }}</el-tag>
              <gj-popover v-else trigger="hover">
                <template slot="reference">
                  <el-tag size="mini" type="danger"
                    >{{ row.adsStatus === 1 ? '活跃' : '不活跃' }}
                    <i class="el-icon-arrow-down"></i>
                  </el-tag>
                </template>
                <div class="ad-status">
                  <span>广告活动</span>
                  <span
                    :style="{
                      color: row.campaignState === 0 ? '#333333' : '#F5222D',
                    }"
                    >{{ row.campaignState === 0 ? '启动中' : '暂停中' }}</span
                  >
                </div>
                <div class="ad-status" v-if="row.objectType !== 'campaign'">
                  <span>广告组</span>
                  <span
                    :style="{
                      color: row.groupState === 0 ? '#333333' : '#F5222D',
                    }"
                    >{{ row.groupState === 0 ? '启动中' : '暂停中' }}</span
                  >
                </div>
                <div class="ad-status" v-if="row.objectType !== 'campaign' && row.objectType !== 'group'">
                  <span>投放</span>
                  <span
                    :style="{ color: row.state === 0 ? '#333333' : '#F5222D' }"
                    >{{ row.state === 0 ? '启动中' : '暂停中' }}</span
                  >
                </div>
              </gj-popover>
            </div>
          </template>
         <template v-slot:campaignName="{ row }">
          <div style=" margin: 0;">{{row.campaignName | defaultShow}}</div>
        </template>
        <template v-slot:objectState="{ row }">
            <gj-switch  @change="handleStrategy($event ? 1 : 0, row)"
                    :value="row.objectState === 'enabled'"></gj-switch>
         </template>
            <template v-slot:op="{ index, row }">
                <gj-button type="text" @click="deleteItem(row)"  v-if="$permission('adsStrategyObject:delete')">移除</gj-button>
                <!-- <gj-button type="text" >编辑</gj-button> -->
            </template>
            </gj-table>
        </template>
       </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, isMeaningfulMixin, queryMixin, isMeaninglessMixin} from "@/minxins";
import {getTemplateApplyPageData, SP, batchRule} from "@/api/ad";
import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
import { mapGetters } from "vuex";
import {optionMap} from '../const';

export default {
  name: "ad-apply-object-modal",
  mixins: [modalMixIn, queryMixin, isMeaningfulMixin, isMeaninglessMixin],
  computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
  },
  props: {
    templateId: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      optionMap,
        filter: {
          marketIdList: [],
          objectName: null,
          adsStatus: null,
          templateState: null,

          
        },
        option: {
          campaignOption: [],
          campaignLoading: false,
          groupOption: [],
          groupLoading: false,
          addOption:[
            {id: "adActive", text: "广告活动"},
            {id: "adGroup", text: "广告组"},
          ],
          activeStatsOption: [
            {id: "1", text: "活跃"},
            {id: "0", text: "不活跃"},
          ],
          ruleStatsOption: [
            {id: "enabled", text: "开启"},
            {id: "paused", text: "暂停"},
          ],
         
        },
        productPickerForm: {
          items: []
        },
        loading: false,
        columns: [
          { id: 'marketId', header: '站点', field: 'option:marketId', minWidth: '100px', options: () => this.marketOption},
          { id: "objectName", header: "应用对象", field: "slot:objectName", minWidth: "300px" },
          { id: "campaignName", header: "广告活动", field: "slot:campaignName", minWidth: "200px"},
          { id: "createTime", header: "应用时间", field: "createTime", minWidth: "140px"},
          { id: "objectState", header: "开启/暂停", field: "slot:objectState", minWidth: "80px"},
          { id: "op", header: "操作", field: "slot:op", width: "100px",fixed: 'right' }
        ],
        tableData:[],
        selectAddList:[],
        isOpen: true,
        
    }
  },
  methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            marketIdList: [],
            objectName: null,
            adsStatus: null,
            templateState: null,
          },
        };
      },
    $gjQuery() {

        const params = {
            model: {
              adsStatus: this.filter.adsStatus,
              marketIdList: this.filter.marketIdList,
              objectName: this.filter.objectName,
              objectState: this.filter.templateState,
              templateId: this.templateId,
            },
            ...this.queryPagination,
            ...this.querySort
          };
        // 查询
        this.loading = true;
        getTemplateApplyPageData(params).then(data => {
          if (isMeaningful(data) && isMeaningful(data.records)) {
            this.pagination = this.getPagination(data);
            this.tableData = data.records;
          } else {
            this.tableData = [];
          }

        }).complete(() => (this.loading = false));

    },
    handleSelectionChange(data) {
          this.selectAddList = data;
      },
    //批量操作
    editAllEvent(status) {
      if (this.selectAddList.length === 0) {
        this.$gjMessage.warning('请先选择需要操作的应用对象!');
        return;
      } 
      var type = '';
      if (status === 'archived') {
        type = '移除';
      }else if (status === 'paused') {
        type = '暂停';
      }else if (status === 'enabled') {
        type = '开启';
      }
  
      const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: '提示',
            content: `已选取${this.selectAddList.length}个对象，确定要${type}选取对象的自动规则吗？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              this.editObject(this.selectAddList, status, (info)=>{
                if (info === 'success') {
                  this.$gjMessage.success(`${type}成功`);
                  this.$emit('change');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                }
              })
            }
          }
      });
    },
    //移除
    deleteItem(row) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: '提示',
            content: `确定要移除"${row.objectName}"的"${this.item.name}"自动规则吗？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              var list = [];
              list.push(row);

              this.editObject(list, 'archived', (info)=>{
                    if (info === 'success') {
                      this.$gjMessage.success('移除成功');
                      this.$emit('change');
                      this.$gjResetPage();
                      modal.$gjDestroy();
                    }
              })
            }
          }
        });
      },
      editObject(data, status, callback) {
        const params = [];
        data.forEach(item => {
              params.push({ 
                marketId: item.marketId, 
                id: item.id, 
                state: status
              })
            })
        batchRule(params).then(res => {
          if(res.code === 0) {
            callback('success');
          } else {
            callback('error');
          }
        }).catch((error) => {
           callback('error');
        })

      },
      //开启/暂停
       handleStrategy(e, row) {
           var list = [];
           list.push(row);
           if (e === 1) { //开启
              this.editObject(list, 'enabled', (info)=>{
                if (info === 'success') {
                  this.$gjMessage.success('操作成功');
                  this.$emit('change');
                  this.$gjResetPage();
                }
              })

           }else {   //暂停
            this.editObject(list, 'paused', (info)=>{
              if (info === 'success') {
                this.$gjMessage.success('操作成功');
                this.$emit('change');
                this.$gjResetPage();
              }
             })

           }
       }
     
  }
}
</script>

<style lang="scss" scoped>
.ad-status {
  color: #333333;
  display: flex;
  justify-content: space-between;
}
.ad-status + .ad-status {
  margin-top: 8px;
}
</style>